import React from 'react'
import PropTypes from 'prop-types'
import './_readOnlyPipeSeprated.scss'
/**
 * ReadOnlyPipeSeprated component displays a label and a value separated by a pipe.
 *
 * @param {Object} props - The component props.
 * @param {string} props.id - The unique identifier for the component.
 * @param {string} [props.label=''] - The label text to display.
 * @param {string} [props.value=''] - The value text to display.
 * @param {boolean} [props.isRightBorderVisible=false] - Flag to determine if the right border should be visible.
 *
 * @returns {JSX.Element} The rendered ReadOnlyPipeSeprated component.
 */
const ReadOnlyPipeSeprated = ({id, label = '', value = '', isRightBorderVisible = false}) => {
  return (
    <>
      <div id={`${id}_label`} className={`rops_label pl-3 text-sm font-normal`}>
        {`${label}:`}
      </div>
      <div
        id={`${id}_value`}
        className={`pl-1 pr-4 text-sm font-normal ${isRightBorderVisible && 'border-r'} rops_label`}
        text={`${value}`}
      >
        {value}
      </div>
    </>
  )
}

ReadOnlyPipeSeprated.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isRightBorderVisible: PropTypes.bool,
}

export default ReadOnlyPipeSeprated
